import { useEffect } from 'react';
export type ProductKey = 'megapack';
type Product = {
  id: string;
  name: string;
  value: number;
  currency: 'ARS';
  checkoutUrl: string;
};
type FacebookPixel = ((...args: unknown[]) => void) & {
  queue?: unknown[][];
  loaded?: boolean;
  version?: string;
};
type PixelWindow = Window & {
  fbq?: FacebookPixel;
  _fbq?: FacebookPixel;
  requestIdleCallback?: (callback: () => void, options?: {
    timeout: number;
  }) => void;
};
export const PRODUCTS: Record<ProductKey, Product> = {
  megapack: {
    id: 'metodo-porcion-rentable-megapack',
    name: 'MEGAPACK MÉTODO PORCIÓN RENTABLE®',
    value: 27990,
    currency: 'ARS',
    checkoutUrl: 'https://metodo-postres-rentables.impultienda.ar/checkout'
  }
};
const PIXEL_ID = '1536689411268055';
function getPixel() {
  const pixel = (window as PixelWindow).fbq;
  return typeof pixel === 'function' ? pixel : null;
}
export function trackInitiateCheckout(productKey: ProductKey) {
  const pixel = getPixel();
  if (!pixel) return;
  const product = PRODUCTS[productKey];
  pixel('track', 'InitiateCheckout', {
    value: product.value,
    currency: product.currency,
    content_ids: [product.id],
    content_name: product.name,
    content_type: 'product',
    num_items: 1
  });
}
export function MetaPixel() {
  useEffect(() => {
    const pageWindow = window as PixelWindow;
    if (pageWindow.fbq) return;
    const pixel = ((...args: unknown[]) => {
      pixel.queue?.push(args);
    }) as FacebookPixel;
    pixel.queue = [];
    pixel.loaded = true;
    pixel.version = '2.0';
    pageWindow.fbq = pixel;
    pageWindow._fbq = pixel;
    pixel('init', PIXEL_ID);
    pixel('track', 'PageView');
    const loadScript = () => {
      if (document.getElementById('facebook-pixel-script')) return;
      const script = document.createElement('script');
      script.id = 'facebook-pixel-script';
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    };
    if (pageWindow.requestIdleCallback) {
      pageWindow.requestIdleCallback(loadScript, {
        timeout: 1800
      });
    } else {
      window.setTimeout(loadScript, 800);
    }
  }, []);
  return null;
}